export * from './lib/metal-detection-form';
